module.exports = __webpack_public_path__ + "155e0d13924cf6726453f5038edfb062.glb";